import RemoveUserRfidCardModal from './RemoveUserRfidCardModal';

export default RemoveUserRfidCardModal;
